import { getPlaybacks } from './getPlaybacks';

import { Store } from '../../../store/list/types';

export const onPageSet = (store: Store, newPage: number): void => {
  const { currentPage, setCurrentPage, setPreviousPage } = store.getState();

  setPreviousPage(currentPage);
  setCurrentPage(newPage);
  onPageChange(store);
};

const onPageChange = (store: Store): void => {
  const { setTrackPageChange } = store.getState();

  setTrackPageChange(true);
  getPlaybacks(store);
};
